export const BENEFIT_FREE_DELIVERY_MODAL_SIZE = 25;
